import React from "react"
import { Query } from "react-apollo"
import FavoriteFile from "../components/FavoriteFile"
import { searchFavorites } from "../queries"

const FavoritesSearch = (props) => {
  const { searchKeyword, trackingLocation } = props

  return (
    <>
      <div className="section-title">Search Results</div>
      <Query
        query={searchFavorites}
        variables={{ keyword: searchKeyword }}
        fetchPolicy="network-only"
      >
        {({ data, loading, error }) => {
          if (error) return <div>Error while getting search results.</div>
          if (data && data.searchFavorites) {
            const results = data.searchFavorites

            return (
              <div className="grid files-grid">
                {!results.length && <div>No favorites found.</div>}
                {results.map((favorite, idx) => {
                  return (
                    <FavoriteFile
                      key={idx}
                      className="col"
                      hasMenu={true}
                      zIndex={0}
                      favorite={favorite}
                      trackingLocation={`${trackingLocation}: Search`}
                    />
                  )
                })}
              </div>
            )
          }

          return null
        }}
      </Query>
    </>
  )
}

export default FavoritesSearch
